import { SigninResponseVO, SigninRequestVO } from "./signin.models";

export abstract class SigninService {

    abstract signin(signInVO: SigninRequestVO): Promise<SigninResponseVO>;
    abstract requestResetLinkMail(username: string): Promise<void>;
}


// WEBPACK FOOTER //
// ./src/app/signin/signin.service.ts